module.exports = __webpack_public_path__ + "static/img/comments_user03@2x.ee0a2c56.png";